import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PENDING_CHANGES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/pendingChanges`,
  {
    SET_PENDING_CHANGES_DATA: 'SET_PENDING_CHANGES_DATA',
    CLEAR_PENDING_CHANGES_DATA: 'CLEAR_PENDING_CHANGES_DATA',
  },
);

export const setLoanSavingRelatedDataAction = ({ metadata } = {}) => ({
  type: PENDING_CHANGES_ACTION_TYPE.SET_PENDING_CHANGES_DATA,
  payload: metadata,
});
